import { memo, useCallback } from "react";
import PropTypes from "prop-types";
import TravellersRoomInput from "app/pages/SmartDP/Search/TravellersRoomInput/TravellersRoomInput";
import "./TravellersRoomFieldset.scss";
import { FormattedMessage } from "react-intl";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { ALERT_TYPE } from "app/constants";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import IconMinus from "app/pages/.shared/static/icons/IconMinus";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";

const TravellersRoomFieldset = ({
	index,
	showRemoveButton,
	onRemoveClick,
	warningMessage = false,
}) => {
	const handleRemoveClick = useCallback(() => {
		onRemoveClick(index);
	}, [index]);

	return (
		<div className="travellers-room-fieldset">
			<div className="travellers-room-fieldset__header">
				<div className="travellers-room-fieldset__title">
					<Typography variant={TYPOGRAPHY_VARIANTS.XL} isBold>
						<FormattedMessage
							id="sdp.search.occupancies.room.label"
							values={{ number: index + 1 }}
						/>
					</Typography>
				</div>

				{showRemoveButton && (
					<Button
						variant={BUTTON_VARIANTS.BORDERLESS}
						size={BUTTON_SIZES.SMALL}
						onClick={handleRemoveClick}
						icon={<IconMinus width={11} height={11} />}
						label={
							<Typography variant={TYPOGRAPHY_VARIANTS.SMALL} isBold>
								<FormattedMessage id="sdp.search.occupancies.room.remove.label" />
							</Typography>
						}
						data-testid={`remove-room-button-${index + 1}`}
						className="travellers-room-fieldset__remove-button"
					/>
				)}
			</div>
			<div className="travellers-room-fieldset__content">
				{warningMessage && (
					<AlertMessage
						alertType={ALERT_TYPE.INFO}
						message={<FormattedMessage id="general.warning.adult.destination.usa" />}
						className="travellers-room-fieldset__warning"
					/>
				)}
				<TravellersRoomInput name={`occupancies.${index}`} index={index} />
			</div>
		</div>
	);
};

TravellersRoomFieldset.propTypes = {
	index: PropTypes.number,
	showRemoveButton: PropTypes.bool,
	onRemoveClick: PropTypes.func,
	warningMessage: PropTypes.bool,
};

export default memo(TravellersRoomFieldset);
